const sortAsc = (a, b, fieldToSort) => {
  const a_str = String(a[fieldToSort]).toLowerCase();
  const b_str = String(b[fieldToSort]).toLowerCase();
  if (a_str > b_str) {
    return 1;
  } else if (b_str > a_str) {
    return -1;
  }
  return 0;
};
const sortDesc = (a, b, fieldToSort) => {
  const a_str = String(a[fieldToSort]).toLowerCase();
  const b_str = String(b[fieldToSort]).toLowerCase();
  if (a_str < b_str) {
    return 1;
  } else if (b_str < a_str) {
    return -1;
  }
  return 0;
};

export const sortAscArray = <T>(sortedArray: T[], fieldToSort: string): T[] =>
  sortedArray.sort((a, b) => sortAsc(a, b, fieldToSort));
export const sortDescArray = <T>(sortedArray: T[], fieldToSort: string): T[] =>
  sortedArray.sort((a, b) => sortDesc(a, b, fieldToSort));
